import { render, staticRenderFns } from "./ttBookingBasic.vue?vue&type=template&id=dbeef84c&scoped=true&"
import script from "./ttBookingBasic.vue?vue&type=script&lang=js&"
export * from "./ttBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./ttBookingBasic.vue?vue&type=style&index=0&id=dbeef84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbeef84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbeef84c')) {
      api.createRecord('dbeef84c', component.options)
    } else {
      api.reload('dbeef84c', component.options)
    }
    module.hot.accept("./ttBookingBasic.vue?vue&type=template&id=dbeef84c&scoped=true&", function () {
      api.rerender('dbeef84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/ttBookingBasic.vue"
export default component.exports